import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from '@material-ui/core';

/**
 * Renders a Tooltip only when the child text is actually truncated (overflowing).
 * Checks scrollWidth > clientWidth after layout so the tooltip never appears
 * for text that fits comfortably within its cell.
 */
const OverflowTooltip = ({ title, children, className = 'table-cell-ellipsis' }) => {
    const ref = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        if (ref.current) {
            setIsOverflowing(ref.current.scrollWidth > ref.current.clientWidth);
        }
    }, [title]);

    return (
        <Tooltip title={title || ''} disableHoverListener={!isOverflowing}>
            <div ref={ref} className={className}>{children}</div>
        </Tooltip>
    );
};

export default OverflowTooltip;
